import { selectIsLoading } from '../createEagGridStore';
import { useEagGridSelector } from '../useEagGridSelector';
export function useGridIsLoading() {
  return useEagGridSelector(selectIsLoading);
}